import moment from 'moment';
import { I18n } from 'react-redux-i18n';

export function extractAuctionData(list) {
  const formattedData = {};

  list.forEach((item) => {
    const {
      store_name,
      market_name,
      date,
      wine_name,
      vintage,
      nb_bottles,
      local_price,
      local_currency
    } = item;
    const momentDate = moment(date);
    const key = `${store_name} - ${market_name} - ${date}`;

    if (!formattedData[key]) {
      formattedData[key] = {
        type: 'distribution',
        title: I18n.t('dashboard.feedTitles.auction'),
        link: '/distribution/auction',
        order: 5,
        origin: store_name,
        date: momentDate.format('DD/MM/YYYY'),
        momentDate,
        descriptionList: []
      };
    }

    const priceString = Number(local_price).toLocaleString('fr-FR', {
      style: 'currency',
      currency: local_currency ? local_currency : 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });

    const vintageString = vintage ? ` ${vintage} ` : '';

    const nbBottleString = nb_bottles
      ? `${nb_bottles} ${I18n.t('bottles')} `
      : '';

    const atString = I18n.t('at');

    formattedData[key].descriptionList.push(
      `${wine_name} ${vintageString} - ${nbBottleString} ${atString} ${priceString}`
    );
  });

  return Object.values(formattedData);
}
